import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';

//Helpers
import mascaras from '../../../../helpers/mascaras';

//API
import destino_api from '../../../../api/destino_api';
import { showMessage } from 'helpers/message';
import Loading from 'components/Loading/Loading';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';

function ModalidadeColeta({ redestinacaoItem, setRedestinacao }) {
  //Estado de controle do loading na tela
  const [loading, setLoading] = useState(false);

  const loadModalidadesDestino = () => {
    setLoading(true)
    destino_api.GetListModalidadeDestino().then(response => {
      response.data = response.data.map(value => {
        return { tbTipoColeta_Id: value.id, modalidade: value.descricao, pesoDestinado: "" }
      });
      
      // Verifica os novos itens que não estão presentes na lista atual
      const novosItens = response.data.filter(item =>
        !redestinacaoItem.redestinacaoTipoColetas.some(existingItem => existingItem.tbTipoColeta_Id === item.tbTipoColeta_Id)
      );

      // Adiciona os novos itens à lista atual
      setRedestinacao({
        ...redestinacaoItem,
        redestinacaoTipoColetas: [...redestinacaoItem.redestinacaoTipoColetas, ...novosItens]
      });
    })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(() => setLoading(false))
  }

  const handleChangePeso = (tbTipoColeta_Id, pesoDestinado) => {
    setRedestinacao({
      ...redestinacaoItem,
      redestinacaoTipoColetas: [...redestinacaoItem.redestinacaoTipoColetas.map((value) => {
        if (value.tbTipoColeta_Id == tbTipoColeta_Id)
          value.pesoDestinado = pesoDestinado;
        return value;
      })]
    })
  }

  //Cabeçalhos da tabela de escala
  const headers = [
    { value: "Modalidade", objectValue: "modalidade", align: "left" },
    {
      value: "Peso (KG)", objectValue: "pesoDestinado", align: "left", options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => (
          <TextField
            type={"text"}
            mask={mascaras.floatMask}
            value={redestinacaoItem.redestinacaoTipoColetas[dataIndex].pesoDestinado}
            onChange={(e) => handleChangePeso(redestinacaoItem.redestinacaoTipoColetas[dataIndex].tbTipoColeta_Id, e.target.value)} />
        )
      }
    },
  ]

  useEffect(() => {
    loadModalidadesDestino();
  }, []);

  return (
    <div className='m-4 p-2 rounded-3 containerStep'>
      {loading && <Loading />}
      <Row className='mb-0'>
        <TabelaListagem
          headers={headers}
          items={redestinacaoItem.redestinacaoTipoColetas}
          options={{ print: false, search: true, pagination: true }}
          title="Lista de modalidades"
        />
      </Row>
    </div>
  );
}

export default ModalidadeColeta;